import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { Grid } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import MUITableLoading from 'components/MUITableLoading/MUITableLoading';
import Layout from 'components/Layout/Layout';
import { GET_PRODUCTS } from '../../../../queries/products/product';
import DrawerNative from '../../../../components/DrawerNative';
import PageError from '../../../../components/PageError';
import PageTitle from '../../../../components/PageTitle/PageTitle';
import { Update } from './edit';
import { AddProducts } from './create';
import DeleteProducts from './delete';

export default function ProductsContent() {
  const [products, setProducts] = useState([]);
  const queryProducts = useQuery(GET_PRODUCTS, {
    fetchPolicy: 'network-only',
  });
  const { loading, error, refetch } = queryProducts;
  const refetchProducts = refetch;

  useEffect(() => {
    if (queryProducts.data) {
      const { data } = queryProducts;
      setProducts(data.listProducts);
    }
  }, [queryProducts]);

  const toolbar = (selectedRows) => (
    <Grid
      container
      spacing={0}
      item
      xs={9}
      alignItems="flex-start"
      justify="flex-end"
      direction="row"
    >
      <Grid item xs={1}>
        <DeleteProducts
          selectedRows={selectedRows}
          products={products}
          refetch={refetchProducts}
        />
      </Grid>
    </Grid>
  );

  const options = {
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    responsive: 'standard',
    customToolbarSelect: toolbar,
  };

  const ActionsRow = (tableMeta) => {
    const name = tableMeta.rowData[0];
    const id = tableMeta.rowData[1];
    const productTypeId = tableMeta.rowData[2];
    const brandId = tableMeta.rowData[3];
    const hotsite = tableMeta.rowData[4];
    const appURL = tableMeta.rowData[5];
    const TOSLink = tableMeta.rowData[6];
    const category = tableMeta.rowData[7];
    const compatibility = tableMeta.rowData[8];
    const lastUpdated = tableMeta.rowData[9];
    const version = tableMeta.rowData[10];

    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <DrawerNative
            title="Edit Products"
            iconButtonAction={false}
            labelButtonAction={name}
            showBtn2
          >
            <Update
              id={id}
              name={name}
              productTypeId={productTypeId}
              brandId={brandId}
              hotsite={hotsite}
              appURL={appURL}
              TOSLink={TOSLink}
              category={category}
              compatibility={compatibility}
              lastUpdated={lastUpdated}
              version={version}
              refetch={refetchProducts}
            />
          </DrawerNative>
        </Grid>
        <Grid item xs={6} />
      </Grid>
    );
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Products" />
        </Grid>
        <Grid item xs={2}>
          <DrawerNative title="Products" labelButtonAction="Add" showBtn2>
            <AddProducts refetch={refetchProducts} />
          </DrawerNative>
        </Grid>
      </Grid>
      {loading ? (
        <MUITableLoading columns={['NAME', 'HOTSITE', 'APP URL', 'TOS LINK', 'CATEGORY', 'COMPATIBILITY', 'LAST UPDATED', 'VERSION']} />
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MUIDataTable
              title={false}
              data={products}
              columns={[
                {
                  name: 'name',
                  label: 'NAME',
                  options: {
                    customBodyRender: (value, tableMeta) => {
                      return ActionsRow(tableMeta);
                    },
                    empty: true,
                    filter: true,
                    sort: true,
                  },
                },
                {
                  name: 'id',
                  label: 'ID',
                  options: {
                    display: false,
                  },
                },
                {
                  name: 'productTypeId',
                  label: 'PRODUCT TYPE ID',
                  options: {
                    display: false,
                  },
                },
                {
                  name: 'brandId',
                  label: 'BRAND ID',
                  options: {
                    display: false,
                  },
                },
                {
                  name: 'hotsite',
                  label: 'HOTSITE',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'appURL',
                  label: 'APP URL',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'TOSLink',
                  label: 'TOS LINK',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'category',
                  label: 'CATEGORY',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'compatibility',
                  label: 'COMPATIBILITY',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'lastUpdated',
                  label: 'LAST UPDATED',
                  options: {
                    display: true,
                  },
                },
                {
                  name: 'version',
                  label: 'VERSION',
                  options: {
                    display: true,
                  },
                },
              ]}
              options={options}
            />
          </Grid>
        </Grid>
      )}
    </Layout>
  );
}
